import { FC } from 'react';

// Components
import PlayerBio from './PlayerBio/PlayerBio';
import { Tournaments, TeamInfo, FormResults, SocialIconsList } from '../common';

// Hooks/Utils
import { defaultHandleEventClick, defaultHandlePlayerClick } from '@sportal365/smp-widget-utils';

// Types
import { ISubscriberInfo } from '../../../../../../packages/types';
import { PlayerInformation } from '../../../types';

interface Props {
  playerInformation: PlayerInformation;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
  showSocialIcons: boolean;
}

const PlayerInformationHeader: FC<Props> = ({ playerInformation, handleClick, showSocialIcons }) => {
  const { player, country, team, playerBio, tournaments, social, form, urlTarget } = playerInformation;

  const handlePlayerClick = () => defaultHandlePlayerClick(handleClick, player.id, player.name);

  const handleFormEventClick = (id: string | number) => defaultHandleEventClick(handleClick, id);

  return (
    <div className='player-information-wrapper flex justify-between pt-4 px-0 tb:px-4 flex-col lg:flex-row'>
      <div className='player-info-wrapper flex gap-4 items-center max-h-[140px] px-4 tb:px-0'>
        <a href={player.url} target={urlTarget} onClick={handlePlayerClick}>
          <img className='player-image max-w-[80px] sm:max-w-[100px] max-h-[80px] sm:max-h-[100px]' src={player.image} />
        </a>
        <div className='player-details-container w-full'>
          <a href={player.url} target={urlTarget} onClick={handlePlayerClick} className='no-underline'>
            <p className='player-name mx-0 mb-2 mt-0 font-bold text-hiContrast text-6 sm:text-[32px]'>{player.name}</p>
          </a>
          <div className='player-clubs-container flex flex-wrap gap-1 flex-col xs:gap-4 xs:flex-row'>
            <TeamInfo {...country} urlTarget={'_self'} className='country' handleClick={handleClick} isClickable={false} />
            <TeamInfo {...team} urlTarget={urlTarget} className='player' handleClick={handleClick} />
          </div>
          <div className='player-overview-desktop-container hidden tb:flex justify-between mt-2'>
            <div className='flex lg:gap-7 gap-2 items-center'>
              <FormResults data={form} handleClick={handleFormEventClick} />
              <Tournaments tournaments={tournaments} handleClick={handleClick} />
            </div>
            {social && (
              <div className='social-icons-wrapper block lg:hidden'>
                <SocialIconsList data={social} showSocialIcons={showSocialIcons} />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='player-overview-mobile-container flex justify-between tb:hidden gap-4 pt-4 px-4 flex-col-reverse xs:flex-row'>
        <FormResults data={form} handleClick={handleFormEventClick} />
        <Tournaments tournaments={tournaments} handleClick={handleClick} />
      </div>
      {social && (
        <div className='social-icons-wrapper block pt-4 px-4 tb:hidden'>
          <SocialIconsList data={social} showSocialIcons={showSocialIcons} />
        </div>
      )}
      <div className='player-bio-wrapper flex flex-col-reverse gap-4 pt-4 lg:pt-0 tb:flex-col tb:gap-2'>
        {playerBio && <PlayerBio {...playerBio} />}
        {social && (
          <div className='social-icons-wrapper px-4 tb:px-0 hidden lg:block'>
            <SocialIconsList data={social} showSocialIcons={showSocialIcons} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerInformationHeader;
